const axios = require('axios')

const url = process.env.VUE_APP_API;
const version = process.env.VUE_APP_API_VERSION;

const axiosRequest = axios.create({
    baseURL: `${url}/${version}`
});

export default {
    namespaced: true,
    state:{
        data: null,
        message: null,
        status: null
    },
    mutations: {
        setData(state, payload){
            state.data = payload;
        },
        setMessage(state, message){
            state.message = message;
        },
        setStatus(state, status){
            state.status = status;
        }
    },
    getters: {},
    actions: {
        async request({commit}, { method, url, headers, data, typeBlob }){
            try{
                if(!method || !url) throw ('Não foi passado o method ou url para acessar a API');


                if(localStorage.getItem('token')){
                    headers = {
                        Authorization: `Bearer ${localStorage.getItem('token')}`
                    }
                }

                let configRequest = {
                    method,
                    url,
                    headers,
                    data
                };

                let result = (await axiosRequest(configRequest));

                commit('setData', result.data.data);
                commit('setStatus', result.data.status || null);
                commit('setMessage', result.data.message || null);
            }catch(error){
                console.log(error)
            }
        }
    }
}